<template>
  <div class="filter-form-dropdown">
    <div
      ref="kFilterFormDropdownRef"
      class="filter-form"
      :class="{
        'on-focus': selectorActive,
        'has-item': itemList.length > 0,
        'has-error': hasError,
        'disabled': isDisabled
      }"
    >
      <div class="items-input" @click="openSelectorOption">
        <!-- 已输入项 -->
        <div class="items">
          <div
            class="item k-body-md"
            :class="{'no-delete': isDisabled, 'item-disabled': isDisabled}"
            v-for="(item, index) in itemList" :key="index"
          >
            <span class="text">{{ item?.label }}</span>
            <span
              v-if="!isDisabled"
              @click.stop="doDeleteItem(item, index)"
            >
              <KkIcon name="ic_cross_line" size="xs" class="kk-u-text-primary-medium k-icon-cursor" />
            </span>
          </div>
          <div class="placeholder-text" v-if="itemList.length == 0">
            {{ placeholder }}
          </div>
        </div>
        <!-- icon -->
        <div
          class="select-icon">
          <img src="@/assets/icons/common/trailing-icon.svg" alt="">
        </div>
      </div>
      <div class="form-dropdown" v-if="selectorActive" :style="{top: kFilterFormDropdownHeight + 'px'}">
        <div class="form-dropdown_slot k-body-md">
          <slot name="dropdown"></slot>
        </div>
      </div>
    </div>
    <div class="clean" v-if="cleanText && itemList.length" @click="$emit('clean')">
      {{ cleanText }}
    </div>
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon
  },
  data() {
    return {
      selectorActive: false,
      kFilterFormDropdownHeight: 0,
      itemList: this.items || []
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    cleanText: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectorActive() {
      // 开关后，元素高度会出现变化
      this.resizeFilterFormDropdownHeight()
    },
    items: {
      handler(val) {
        this.itemList = val
        this.resizeFilterFormDropdownHeight()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // 元素高度监听
    const resizeHeightListener = () => {
      this.resizeFilterFormDropdownHeight()
    }
    window.addEventListener('resize', resizeHeightListener)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', resizeHeightListener)
    })
  },
  methods: {
    resizeFilterFormDropdownHeight() {
      this.$nextTick(() => {
        if (this.$refs.kFilterFormDropdownRef) {
          this.kFilterFormDropdownHeight = this.$refs.kFilterFormDropdownRef.offsetHeight + 4
        }
      })
    },
    openSelectorOption() {
      if (this.isDisabled) return
      if (!this.selectorActive) {
        this.selectorActive = true
      }
    },
    closeSelectorOption() {
      this.selectorActive = false
    },
    doDeleteItem(item, index) {
      if (item?.delete) {
        this.$emit('delete', item, index)
      }
      this.resizeFilterFormDropdownHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.filter-form-dropdown {
  display: flex;
  // 边框状态：正常状态、焦点状态、鼠标悬停
  .filter-form:hover {
    border: 1px solid #212121;
  }
  .has-error {
    border: 1px solid #E65F50 !important;
  }
  .on-focus {
    border: 1px solid #212121 !important;
  }
  .has-item {
    padding: 2px 48px 2px 12px !important;
    height: unset !important;
  }
  .disabled {
    border: 1px solid #E6E9ED !important;
    color: #BABBBE !important;
    background-color: #F1F4F8 !important;
    cursor: no-drop;
    cursor: not-allowed;
  }
  .filter-form {
    position: relative;
    width: 100%;
    max-width: 942px;
    display: flex;
    flex: 1;
    justify-content: flex-end;
    box-sizing: border-box;
    padding: 3px 48px 3px 12px;
    min-height: 48px;
    border: 1px solid #D5D6DB;
    border-radius: 8px;
    background-color: #FFF;
    .items-input {
      width: 100%;
      .items {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: wrap;
        align-items: center;
        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding: 6px 10px 6px 14px;
          margin-top: 4px;
          margin-bottom: 4px;
          margin-right: 8px;
          border-radius: 20px;
          color: #26BEC9;
          border: 1px solid #26BEC9;
          background-color: #F0FAFB;
          .text {
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            word-break: break-all;
            text-align: left;
          }
        }
        .placeholder-text {
          color: #BABBBE;
        }
        .item-disabled {
          color: #ADE6EB !important;
          border: 1px solid #ADE6EB !important;
        }
        .no-delete {
          padding: 6px 14px !important;
        }
      }
      .select-icon {
        position: absolute;
        top: 14px;
        right: 12px;
      }
    }
    .form-dropdown {
      position: absolute;
      bottom: 0px;
      width: 100%;
      left: 0px;
      z-index: 2001;
      .form-dropdown_slot {
        min-height: 100px;
        padding: var(--kk-spacing-8) var(--kk-spacing-7);
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 24px 0 rgba(38, 50, 56, .12);
      }
    }
  }
  .clean {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: #26BEC9;
    padding: 0px var(--kk-spacing-7);
    padding-top: 12px;
    box-sizing: border-box;
    margin-left: var(--kk-spacing-4);
  }
}
</style>
